import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id F93B3000-FF04-4374-94AB-7E703AE780AD
 * name relation-only-one-to-zero-or-one
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/relation-only-one-to-zero-or-one.svg
 * tags
 * - Database 
 */
export const RelationOnlyOneToZeroOrOneIcon = createSvgIcon(<><path d="M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H8V5H6V7H5V5H3V7H2V9H3V11H5V9H6V11H8V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z" /></>, 'RelationOnlyOneToZeroOrOneIcon');
export default RelationOnlyOneToZeroOrOneIcon